import { FunctionComponent } from 'react';
import * as S from './styles';

type HeaderProps = {
  userName: string;
};

export const Header: FunctionComponent<HeaderProps> = ({ userName }) => {
  return (
    <S.Container>
      <S.WrapperTitle>
        <S.Title level={2}>{userName}, você entrou na fila</S.Title>
        <S.TitleSpan>
          Fique tranquilo, enviaremos uma mensagem quando chegar a sua vez.
        </S.TitleSpan>
      </S.WrapperTitle>
    </S.Container>
  );
};
